import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  position: relative;\n  box-sizing: border-box;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import Card from './Card';
import InfoCardImage from '../Info/InfoCardImage';
import InfoCardContent from '../Info/InfoCardContent';
import InfoLink from '../Info/InfoLink';
import { padding } from '../style/padding';
import { marginTop } from '../style/margin-top';
export var CARD_INFO_PADDING = 16;
var ContentWrapper = styled.div(_templateObject(), padding(CARD_INFO_PADDING));
var StyledInfoLink = styled(InfoLink)(_templateObject2(), marginTop(16));
var CardInfo = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var _ref$fixedHeight = _ref.fixedHeight,
      fixedHeight = _ref$fixedHeight === void 0 ? true : _ref$fixedHeight,
      imageHeight = _ref.imageHeight,
      _ref$imageSize = _ref.imageSize,
      imageSize = _ref$imageSize === void 0 ? 'tiny' : _ref$imageSize,
      image = _ref.image,
      topRightIcon = _ref.topRightIcon,
      topLeftIcon = _ref.topLeftIcon,
      kickerTitle = _ref.kickerTitle,
      kickerAs = _ref.kickerAs,
      title = _ref.title,
      _ref$titleLines = _ref.titleLines,
      titleLines = _ref$titleLines === void 0 ? 1 : _ref$titleLines,
      titleAs = _ref.titleAs,
      subTitle = _ref.subTitle,
      bodyTitle = _ref.bodyTitle,
      _ref$bodyLines = _ref.bodyLines,
      bodyLines = _ref$bodyLines === void 0 ? 3 : _ref$bodyLines,
      linkTitle = _ref.linkTitle,
      linkHref = _ref.linkHref,
      linkTarget = _ref.linkTarget,
      _ref$linkProps = _ref.linkProps,
      linkProps = _ref$linkProps === void 0 ? {} : _ref$linkProps,
      onLinkClick = _ref.onLinkClick,
      props = _objectWithoutPropertiesLoose(_ref, ["fixedHeight", "imageHeight", "imageSize", "image", "topRightIcon", "topLeftIcon", "kickerTitle", "kickerAs", "title", "titleLines", "titleAs", "subTitle", "bodyTitle", "bodyLines", "linkTitle", "linkHref", "linkTarget", "linkProps", "onLinkClick"]);

  var as = linkProps.as,
      restLinkProps = _objectWithoutPropertiesLoose(linkProps, ["as"]);

  return /*#__PURE__*/React.createElement(Card, _extends({
    ref: forwardedRef,
    size: 'medium'
  }, props), /*#__PURE__*/React.createElement(InfoCardImage, {
    imageHeight: imageHeight,
    imageSize: imageSize,
    image: image,
    topLeftIcon: topLeftIcon,
    topRightIcon: topRightIcon
  }), /*#__PURE__*/React.createElement(ContentWrapper, null, /*#__PURE__*/React.createElement(InfoCardContent, {
    size: 'medium',
    fixedHeight: fixedHeight,
    kickerTitle: kickerTitle,
    kickerAs: kickerAs,
    title: title,
    titleLines: titleLines,
    titleAs: titleAs,
    subTitle: subTitle,
    bodyTitle: bodyTitle,
    bodyLines: bodyLines
  }), linkTitle && /*#__PURE__*/React.createElement(StyledInfoLink, _extends({
    arrow: "right",
    href: linkHref,
    target: linkTarget,
    onClick: onLinkClick,
    forwardedAs: as
  }, restLinkProps), linkTitle)));
});
export default CardInfo;